import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../../environments/environment';
import { SecurityHelper } from '../../../../pages/common/securityHelper';
import { LoginService } from '../../../../pages/login/login.service';
import { UserDto } from '../../../../pages/security/model/userDto';
import { DbContextService } from '../../../../services/db-context.service';
import { OfflineQueueService } from '../../../../services/offline-queue.service';
import { OnlineOfflineService } from '../../../../services/online-offline.service';
import swal from 'sweetalert2';

@Component({
  standalone: false,
  selector: 'app-custom-login',
  templateUrl: './custom-login.component.html',
  styleUrls: ['./custom-login.component.scss']
})
export class CustomLoginComponent implements OnInit {

  registerForm!: FormGroup;
  submitted = false;
  passwordCorrect: Boolean = true;

  // validation
  public errorMessageList: string[] = [];

  constructor(private router: Router, private loginServ: LoginService, public readonly onlineOfflineService: OnlineOfflineService, private modalService: NgbModal,
    public readonly offlineQueue: OfflineQueueService,
    private formBuilder: FormBuilder,
    public dbStore: DbContextService,
    private http: HttpClient,
    private toasts: ToastrService) { }

  ngOnInit() {

    this.dbStore.openDatabase();
    this.registerForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });

    SecurityHelper.SetUnAutheticatedWS();
    SecurityHelper.SetHTTPRequestsUnathorized(false);

  }

  // Sign in
  onSubmit() {
    this.submitted = true;

    // stop the process here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }

    this.loginServ.logIn(this.registerForm.get('username')!.value, this.registerForm.get('password')!.value)!.pipe().subscribe(
      (res: any) => {

        if (this.isResponseValid(res)) {
          let userDto: UserDto = res.entity.list[0];
          this.allowAccess(userDto);
        }

      }
    );
  }

  private allowAccess(userDto: any) {


    // store userData
    SecurityHelper.SetLoggedInUserDto(userDto);
    SecurityHelper.SetAutheticatedWS();

    this.modalService.dismissAll();

    if (this.onlineOfflineService.isOnline && this.onlineOfflineService.isAuthenticated) {
      this.offlineQueue.resyncData();
    }

  }

  isResponseValid(res: any): boolean {
    // reset validation
    this.errorMessageList = [];

    if (res.errorMessage.length > 0) {

      if (res.errorMessage[0].code == "9525") {

        this.modalService.dismissAll();

        swal.fire({
          title: 'Password Expired',
          html: '<span>Your password is already expired.<br>Please log in again to continue.</span>',
          icon: "error",
          showCloseButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
          .then((result) => {
            if (result.value) {
              SecurityHelper.GoBackToLoginPage();
            }
          });

      }

      this.errorMessageList.push(res.errorMessage[0].message);
    }

    return (this.errorMessageList.length === 0);
  }

}
